module.exports = __webpack_public_path__ + "static/assets/8d07e62a9a72b438a4e4818bc423085d.svg";